import(/* webpackMode: "eager" */ "/codebuild/output/src1016919225/src/apps/web/app/[locale]/error.tsx");
